import { render } from "./ProfilesListModalContainer.vue?vue&type=template&id=908aa5e8&ts=true"
import script from "./ProfilesListModalContainer.vue?vue&type=script&lang=ts"
export * from "./ProfilesListModalContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__